import React from 'react'

import logo from '../../../assets/images/logoCampana.png'
import elPoder from '../../../assets/images/elPoder.png'

import './polygon-template.scss'
import PoligonLogo from '../../atoms/poligon-logo/poligon-logo'

export default function PolygonTemplate(props) {
  const { children } = props
  return (
    <div className="polygon-template">
      <div className="polygon-template-container">
        <div className="polygon-template-container__logo">
          <PoligonLogo />
        </div>
        <div className="polygon-template-container__body">{children}</div>
      </div>
    </div>
  )
}
